import { getOrgUsers } from '../api/orgs';

const ADD_ORG_USERS = 'ADD_ORG_USERS';
const LOADED_ALL_ORG_USERS = 'LOADED_ALL_ORG_USERS';
const REMOVE_USER_ORG = 'REMOVE_USER_ORG';
const ADD_USER_ORG = 'ADD_USER_ORG';
const REMOVE_ORG_USERS = 'REMOVE_ORG_USERS';

const INITIAL_STATE = {
  isOrgUsersLoaded: false,
  users: [],
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_ORG_USERS:
      return {
        ...state,
        users: [...action.payload],
      };
    case LOADED_ALL_ORG_USERS:
      return {
        ...state,
        isOrgUsersLoaded: true,
      };
    case REMOVE_USER_ORG:
      return {
        ...state,
        users: state.users
          .filter(u => u.orgId === action.payload.orgId)
          .filter(u => u.userId !== action.payload.userId),
      };
    case ADD_USER_ORG:
      return {
        ...state,
        users: [...state.users, action.payload],
      };
    case REMOVE_ORG_USERS:
      return {
        isOrgUsersLoaded: false,
        users: [],
      };
    default:
      return state;
  }
}

export function fetchOrgUsers() {
  // eslint-disable-next-line no-unused-vars
  return async (dispatch) => {
    try {
      const { data } = await getOrgUsers();

      dispatch({
        type: ADD_ORG_USERS,
        payload: data,
      });

      return dispatch({ type: LOADED_ALL_ORG_USERS });
    } catch (error) {
      return Promise.reject(error);
    }
  };
}

export function addUserToOrg(user) {
  return {
    type: ADD_USER_ORG,
    payload: { ...user },
  };
}

export function removeUserFromOrg(orgId, userId) {
  return {
    type: REMOVE_USER_ORG,
    payload: { orgId, userId },
  };
}

export function removeOrgUsers() {
  return {
    type: REMOVE_ORG_USERS,
  };
}
